import dayjs, { Dayjs } from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

dayjs.extend(isoWeek)

// Подпись под числом в крупной ячейке (large): время смены, «замена», код КС и т. п.
// Данные готовит consumer; календарь только выводит текст, тон задаёт состояние дня.
export interface CalendarDayLabel {
    text: string
    // Фон плашки (код кадрового состояния). Без значения — подпись без плашки.
    background?: string
}

export type CalendarRangePresetId = 'this-week' | 'last-week' | 'this-month' | 'last-month' | 'last-3-months'

export interface CalendarRangePreset {
    id: CalendarRangePresetId
    label: string
    start: Dayjs
    end: Dayjs
}

// Быстрый выбор периода (RD-160): today — календарный день профиля (calendarTime.ts, D-001); недели Пн–Вс, месяцы календарные,
// «Последние 3 мес.» — с 1-го числа месяца два месяца назад до конца текущего месяца.
export function calendarRangePresets(today: Dayjs): CalendarRangePreset[] {
    const day = today.startOf('day')
    const weekStart = day.startOf('isoWeek')
    const monthStart = day.startOf('month')
    const lastMonthStart = monthStart.subtract(1, 'month')
    return [
        { id: 'this-week', label: 'Эта неделя', start: weekStart, end: weekStart.add(6, 'day') },
        { id: 'last-week', label: 'Прошлая неделя', start: weekStart.subtract(7, 'day'), end: weekStart.subtract(1, 'day') },
        { id: 'this-month', label: 'Этот месяц', start: monthStart, end: monthStart.endOf('month').startOf('day') },
        { id: 'last-month', label: 'Прошлый месяц', start: lastMonthStart, end: lastMonthStart.endOf('month').startOf('day') },
        { id: 'last-3-months', label: 'Последние 3 мес.', start: monthStart.subtract(2, 'month'), end: monthStart.endOf('month').startOf('day') },
    ]
}

export const CALENDAR_QUARTERS = ['I кв.', 'II кв.', 'III кв.', 'IV кв.']
export const CALENDAR_MONTH_NAMES = ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек']
export const CALENDAR_WEEK_DAYS = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС']

export const calendarDateKey = (date: Dayjs) => date.format('YYYY-MM-DD')

// Первое число месяца без переполнения дня (31 октября → февраль не уходит в март).
export const calendarMonthStart = (year: number, month: number) => dayjs(new Date(year, month, 1))
